import { getType } from 'typesafe-actions';

import { getHAOpsDashboard } from './actions';
import { HAOpsDashboardData } from './types';

export interface HAOpsDashboardState {
  dashboardData: {
    data: HAOpsDashboardData | null;
    loading: boolean;
  };
}

const initialState: HAOpsDashboardState = {
  dashboardData: {
    data: null,
    loading: false,
  },
};

export const haOpsDashboardReducer = (
  state = initialState,
  action: any,
): HAOpsDashboardState => {
  switch (action.type) {
    case getType(getHAOpsDashboard.request):
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          loading: true,
        },
      };

    case getType(getHAOpsDashboard.success):
      return {
        ...state,
        dashboardData: {
          data: action.payload,
          loading: false,
        },
      };

    case getType(getHAOpsDashboard.failure):
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          loading: false,
        },
      };

    default:
      return state;
  }
};
